<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">تفاصيل الدورة</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->

    <!-- Loader -->
    <div v-if="loading" class="loader text-success">
      جاري التحميل
      <div class="spinner-border text-success" role="status">
        <span class="sr-only"></span>
      </div>
    </div>

    <!-- Content -->
    <div v-else id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="card">
            <div class="card-body p-lg-17">
              <!--begin::Hero-->
              <div class="position-relative mb-17">
                <!--begin::Overlay-->
                <input
                  type="hidden"
                  id="videoCurrentTime"
                  name="videoCurrentTime"
                  value="0"
                />

                <div class="overlay overlay-show">
                  <div class="m-1 blog__card--thumbnail">
                    <img
                      class="rounded"
                      :src="`${courseDetails.course.preview_image}`"
                      @error="setDefaultImage"
                      alt="Course Thumbnail"
                    />
                  </div>
                  <!--end::Image-->
                  <!--begin::layer-->
                  <div class="overlay-layer rounded bg-black" style="opacity: 0.4"></div>
                  <!--end::layer-->
                </div>
                <!--end::Overlay-->
                <!--begin::Heading-->
                <div class="position-absolute text-white mb-8 ms-10 bottom-0">
                  <!--begin::Title-->
                  <h3 class="text-white fs-2qx fw-bold mb-3 m">
                    {{ courseDetails.course.title }}
                  </h3>
                  <!--end::Title-->
                  <!--begin::Text-->
                  <div class="fs-5 fw-semibold">
                    {{ courseDetails.course.short_detail }}
                  </div>

                  <!--end::Text-->
                </div>
                <!--end::Heading-->
              </div>
              <!--begin::Position-->
              <div class="mb-9">
                <!-- Your card body content here -->
                <!-- Add to Cart Button -->
                <button
                  class="btn btn-success addtocart float-end"
                  v-if="
                    !isEnrolled(courseDetails.course.id) &&
                    (courseDetails.course.price > 0 ||
                      courseDetails.course.discount_price > 0)
                  "
                  @click="addToCart(courseDetails.course.id, $event, 'course')"
                >
                  إضافة إلى السلة <i class="fas fa-cart-plus"></i>
                </button>
                <button
                  class="btn btn-success addtocart float-end"
                  v-if="
                    !isEnrolled(courseDetails.course.id) &&
                    (courseDetails.course.price == null || courseDetails.course.price == 0) &&
                    (courseDetails.course.discount_price == null || courseDetails.course.discount_price == 0)
                  "
                  @click="enrollFree(courseDetails.course.id)"
                >
                  إشتراك في الدورة <i class="fas fa-plus"></i>
                </button>
                <!--begin::Info heading-->
                <div
                  v-if="!isEnrolled(courseDetails.course.id)"
                  class="fw-bold m-3 float-end"
                >
                  <template
                    v-if="
                      (courseDetails.course.price === null ||
                        courseDetails.course.price === 0) &&
                      courseDetails.course.discount_price === null
                    "
                  >
                    <h1 class="text-success">مجاني</h1>
                  </template>
                  <template v-else-if="courseDetails.course.discount_price">
                    <h1 class="text-danger">
                      {{ courseDetails.course.discount_price }} د.ل
                    </h1>
                    <span class="text-muted text-decoration-line-through"
                      >{{ courseDetails.course.price }} د.ل</span
                    >
                    <span class="text-success"
                      >({{
                        calculateDiscountPercentage(
                          courseDetails.course.price,
                          courseDetails.course.discount_price
                        )
                      }}% تخفيض)</span
                    >
                  </template>
                  <template v-else>
                    <h1 class="text-success">{{ courseDetails.course.price }} د.ل</h1>
                  </template>
                </div>
                <!--end::Info heading-->
                <!--begin::Badge-->
                <div class="badge badge-lg badge-light-success d-inline">
                  {{ courseDetails.course.category.title }}
                </div>
                <!--<a
                  href="#"
                  style="font-weight: 800; font-size: 16px; color: #000"
                  class="badge badge-light m-2"
                >
                  <i class="fa fa-user text-success m-1"
                    ><span class="path1"></span><span class="path2"></span
                  ></i>
                  {{ courseDetails.student_enrolled }} مشترك
                </a>-->
                <a
                  href="#"
                  style="font-weight: 800; font-size: 16px; color: #50cd89"
                  class="badge badge-light m-2"
                >
                  <i class="fa fa-play-circle fs-3 text-success m-1"
                    ><span class="path1"></span><span class="path2"></span
                  ></i>
                  {{ totalClasses }} محاضرات
                </a>
                <!--<a target="_blank" v-if="courseDetails.course.tele_group" :href="courseDetails.course.tele_group" style="
                    font-weight: 800;
                    font-size: 16px;
                    color: white;
                    background-color: rgb(0 173 255);
                  " class="badge badge-light m-2">
                  <i class="bi bi-telegram fs-3 text-white m-1"><span class="path1"></span><span
                      class="path2"></span></i>
                  رابط المجموعة
                </a>-->
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#share-modal"
                  style="
                    font-weight: 800;
                    font-size: 10px;
                    color: #07c232;
                    background-color: #89898929;
                  "
                  class="badge badge-light m-2"
                >
                  <i
                    class="bi bi-share fs-3 text-white m-1"
                    style="color: #07c232 !important"
                    ><span class="path1"></span><span class="path2"></span
                  ></i>
                  مشاركة في التطبيق
                </a>
                <a
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#share-web-modal"
                  style="
                    font-weight: 800;
                    font-size: 10px;
                    color: white;
                    background-color: #06a23fc4;
                  "
                  class="badge badge-light m-2"
                >
                  <i class="bi bi-share fs-3 text-white m-1"
                    ><span class="path1"></span><span class="path2"></span
                  ></i>
                  مشاركة في الموقع
                </a>
                <!--<a
                  href="#"
                  data-bs-toggle="modal" 
                  data-bs-target="#share-web-modal"
                  style="
                    font-weight: 800;
                    font-size: 10px;
                    color: white;
                    background-color: #ef2e2e;
                  "
                  class="badge badge-light m-2"
                >
                  <i class="bi bi-circle-fill fs-3 text-white m-1"
                    ><span class="path1"></span><span class="path2"></span
                  ></i>
                  بث مباشر
                </a>-->
                <!--begin::Badge-->
              </div>
              <!--end::Position-->
            </div>
          </div>
        </div>
        <div class="d-flex flex-column flex-lg-row">
          <!-- Sidebar -->
          <div class="flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10">
            <div class="card mb-5 mb-xl-8">
              <div class="card-body">
                <!--begin::Summary-->
                <!--begin::User Info-->
                <div class="d-flex flex-center flex-column py-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-100px symbol-circle mb-7">
                    <img :src="`${courseDetails.course.preview_image}`" alt="image" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Name-->
                  <a href="#" class="fs-3 text-gray-800 text-hover-primary fw-bold mb-3">
                    {{ courseDetails.course.user.fname }}
                    {{ courseDetails.course.user.lname }}
                  </a>
                  <!--end::Name-->
                  <!--begin::Position-->
                  <div class="mb-9">
                    <!--begin::Badge-->
                    <div class="badge badge-lg badge-light-success d-inline">
                      Academia Instructor
                    </div>
                    <!--begin::Badge-->
                  </div>
                  <!--end::Position-->
                  <!--begin::Info-->
                  <!--begin::Info heading-->

                  <!--end::Info-->
                </div>
                <!--end::User Info-->
                <!--end::User Info-->
                <!--end::Summary-->
                <!--begin::Details toggle-->
                <!--end::Details toggle-->
                <!--begin::Details content-->
                <!--end::Details content-->
              </div>
            </div>
          </div>
          <!-- Content -->
          <div class="flex-lg-row-fluid ms-lg-15">
            <!-- Tabs -->
            <ul
              class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8"
            >
              <li class="nav-item">
                <a
                  class="nav-link text-active-primary pb-4 active"
                  data-bs-toggle="tab"
                  href="#kt_user_view_overview_tab"
                  >المحاضرات</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_overview_tab"
                  >نبذة عامة</a
                >
              </li>

              <!-- Add more tabs if needed -->
            </ul>
            <!-- Tab content -->
            <div class="tab-content">
              <div class="tab-pane fade" id="kt_overview_tab" role="tabpanel">
                <div class="card pt-4 mb-6 mb-xl-9">
                  <div class="card-header border-0"></div>
                  <div class="card-body pt-0 pb-5">
                    <!-- Units and Chapters Accordion -->
                    <div class="mt-n20 position-relative course-states">
                      <!--begin::Row-->
                      <div class="row g-3 g-lg-6 text-center">
                        <!--begin::Col-->
                        <div class="col-md-6">
                          <!--begin::Items-->
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <!--begin::Symbol-->
                            <div class="symbol mb-8">
                              <span class="symbol-label">
                                <!--begin::Svg Icon | path: icons/duotune/medicine/med005.svg-->
                                <span class="svg-icon svg-icon-1 svg-icon-primary">
                                  <i class="fa fa-play-circle fs-3qx text-success"></i>
                                </span>
                                <!--end::Svg Icon-->
                              </span>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Stats-->
                            <div class="m-0">
                              <!--begin::Number-->
                              <span
                                class="text-gray-700 fw-bolder d-block fs-3 lh-1 ls-n1 mb-1"
                                >{{ totalClasses }}</span
                              >
                              <!--end::Number-->
                              <!--begin::Desc-->
                              <span class="text-gray-500 fw-semibold fs-6"
                                >المحاضرات</span
                              >
                              <!--end::Desc-->
                            </div>
                            <!--end::Stats-->
                          </div>
                          <!--end::Items-->
                        </div>
                        <!--end::Col-->
                        <!--begin::Col-->
                        <div class="col-md-6">
                          <!--begin::Items-->
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <!--begin::Symbol-->
                            <div class="symbol mb-8">
                              <span class="symbol-label">
                                <!--begin::Svg Icon | path: icons/duotune/finance/fin001.svg-->
                                <span class="svg-icon svg-icon-1 svg-icon-primary">
                                  <i class="fa fa-book fs-3qx text-success"></i>
                                </span>
                                <!--end::Svg Icon-->
                              </span>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Stats-->
                            <div class="m-0">
                              <!--begin::Number-->
                              <span
                                class="text-gray-700 fw-bolder d-block fs-3 lh-1 ls-n1 mb-1"
                                >{{ totalChapters }}</span
                              >
                              <!--end::Number-->
                              <!--begin::Desc-->
                              <span class="text-gray-500 fw-semibold fs-6">الأقسام</span>
                              <!--end::Desc-->
                            </div>
                            <!--end::Stats-->
                          </div>
                          <!--end::Items-->
                        </div>
                        <!--end::Col-->
                        <!--begin::Col-->
                        <div class="col-md-6">
                          <!--begin::Items-->
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <!--begin::Symbol-->
                            <div class="symbol mb-8">
                              <span class="symbol-label">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen020.svg-->
                                <span class="svg-icon svg-icon-1 svg-icon-primary">
                                  <i class="fa fa-user fs-3qx text-success"></i>
                                </span>
                                <!--end::Svg Icon-->
                              </span>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Stats-->
                            <div class="m-0">
                              <!--begin::Number-->
                              <span
                                class="text-gray-700 fw-bolder d-block fs-3 lh-1 ls-n1 mb-1"
                              >
                                {{ courseDetails.course.user.fname }}
                                {{ courseDetails.course.user.lname }}</span
                              >
                              <!--end::Number-->
                              <!--begin::Desc-->
                              <span class="text-gray-500 fw-semibold fs-6"
                                >الأستاذ المحاضر</span
                              >
                              <!--end::Desc-->
                            </div>
                            <!--end::Stats-->
                          </div>
                          <!--end::Items-->
                        </div>
                        <!--end::Col-->
                        <!--begin::Col-->
                        <div class="col-md-6">
                          <!--begin::Items-->
                          <div class="bg-gray-100 bg-opacity-70 rounded-2 px-6 py-5">
                            <!--begin::Symbol-->
                            <div class="symbol mb-8">
                              <span class="symbol-label">
                                <!--begin::Svg Icon | path: icons/duotune/general/gen013.svg-->
                                <span class="svg-icon svg-icon-1 svg-icon-primary">
                                  <i class="fa-solid fa-clock fs-3qx text-success"></i>
                                </span>
                                <!--end::Svg Icon-->
                              </span>
                            </div>
                            <!--end::Symbol-->
                            <!--begin::Stats-->
                            <div class="m-0">
                              <!--begin::Number-->
                              <span
                                class="text-gray-700 fw-bolder d-block fs-3 lh-1 ls-n1 mb-1"
                                >{{
                                  formattedDuration(courseDetails.course.duration)
                                }}</span
                              >
                              <!--end::Number-->
                              <!--begin::Desc-->
                              <span class="text-gray-500 fw-semibold fs-6"
                                >مدة الدورة</span
                              >
                              <!--end::Desc-->
                            </div>
                            <!--end::Stats-->
                          </div>
                          <!--end::Items-->
                        </div>
                        <!--end::Col-->
                      </div>
                      <!--end::Row-->
                    </div>
                    <!-- End of Accordion -->
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show active"
                id="kt_user_view_overview_tab"
                role="tabpanel"
              >
                <div class="card pt-4 mb-6 mb-xl-9">
                  <div class="card-header border-0"></div>
                  <div class="card-body pt-0 pb-5">
                    <!-- Units List -->
                    <div v-for="unit in units" :key="unit.id" class="unit-section">
                      <h3>
                        <input
                          v-if="isEnrolled(courseDetails.course.id)"
                          type="checkbox"
                          class="custom-checkbox"
                          :checked="unit.is_checked"
                          @change="toggleCheck(unit, 'Unit')"
                        />
                        {{ unit.title }}
                        <span class="time-duration" dir="ltr"
                          ><i class="bi bi-clock"></i>
                          {{ formattedDuration(unit.duration) }}</span
                        >
                      </h3>

                      <!-- Chapters Accordion for each Unit -->
                      <div class="accordion" :id="'accordion' + unit.id">
                        <div
                          v-for="(chapter, chapterIndex) in unit.chapters"
                          :key="chapter.id"
                          class="accordion-item"
                        >
                          <h2
                            class="accordion-header"
                            :id="'heading' + chapterIndex + '-' + unit.id"
                          >
                            <button
                              class="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="'#collapse' + chapterIndex + '-' + unit.id"
                              aria-expanded="true"
                              :aria-controls="'collapse' + chapterIndex + '-' + unit.id"
                            >
                              <input
                                v-if="isEnrolled(courseDetails.course.id)"
                                type="checkbox"
                                class="custom-checkbox"
                                :checked="chapter.is_checked"
                                @change="toggleCheck(chapter, 'course_chapter', unit)"
                                style="margin-right: 10px"
                              />
                              {{ chapter.title }}
                              <br />
                              <span class="time-duration float-left"
                                ><i class="bi bi-clock"></i>
                                {{ formattedDuration(chapter.duration) }}</span
                              ><br />
                            </button>
                          </h2>

                          <div
                            :id="'collapse' + chapterIndex + '-' + unit.id"
                            :class="[
                              'accordion-collapse',
                              'collapse',
                              chapterIndex === selectedChapterIndex ? 'show' : '',
                            ]"
                            :aria-labelledby="'heading' + chapterIndex + '-' + unit.id"
                          >
                            <div class="accordion-body">
                              <ul>
                                <li
                                  v-for="classItem in chapter.classes"
                                  :key="classItem.id"
                                  style="width: 100%"
                                >
                                  <input
                                    v-if="isEnrolled(courseDetails.course.id)"
                                    type="checkbox"
                                    class="custom-checkbox"
                                    :checked="classItem.is_checked"
                                    @change="
                                      toggleCheck(classItem, 'course_class', chapter)
                                    "
                                    style="margin-right: 5px"
                                  />
                                  {{ classItem.title }}
                                  <div class="btns" style="float: left">
                                    <!-- باقي الأكشنات كما هي -->
                                    <span
                                      v-if="
                                        classItem.vc != null &&
                                        classItem.type == 'video' &&
                                        classItem.is_live != true
                                      "
                                      class="btn btn-success play-video"
                                      @click="playClass(classItem)"
                                      ><i class="fa fa-play"></i
                                    ></span>
                                    <span
                                      v-if="
                                        classItem.vc != null &&
                                        isEnrolled(courseDetails.course.id) &&
                                        classItem.type == 'link' &&
                                        classItem.is_live != true
                                      "
                                      class="btn btn-success play-video"
                                      data-bs-toggle="modal"
                                      data-bs-target="#view-link-modal"
                                      ><i class="fa fa-link"></i
                                    ></span>
                                    <span
                                      v-if="
                                        classItem.vc != null &&
                                        isEnrolled(courseDetails.course.id) &&
                                        classItem.is_live == true
                                      "
                                      class="btn btn-danger play-video"
                                      style="
                                        background-color: #ff0000 !important;
                                        padding: 5px 10px !important;
                                        font-size: smaller;
                                      "
                                      @click="playClass(classItem)"
                                      ><i class="fa fa-circle"></i> مباشر
                                    </span>
                                    <span
                                      v-if="classItem.type == 'pdf'"
                                      class="btn btn-danger play-video"
                                      @click="showPdf(classItem)"
                                      style="
                                        float: left;
                                        background: #d42d00 !important;
                                        padding: 5px 17px !important;
                                      "
                                      ><i
                                        class="fa fa-file-pdf"
                                        style="font-size: large"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                    <span class="time-duration"
                                      ><i class="bi bi-clock"></i>
                                      {{ formattedDuration(classItem.duration) }}</span
                                    >
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add more tab panes as per your requirement -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <VideoClass ref="vdRef" />
  <ShareModal />
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="view-link-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">مشاهذة محتوى الدورة</h5>
        </div>
        <div class="modal-body" style="text-align: center">
          <h4 class="mb-2 text-center support-text">
            يمكنك مشاهدة الرابط عبر تحميل تطبيق أكاديميا من الرابط أدناه
          </h4>
          <div class="support-box">
            <img
              class="support-img text-center"
              width="250"
              src="assets/img/logo-dark.png"
              alt=""
            />
          </div>
          <hr />
          <div class="text-center">
            <h5 class="download-app">
              <i class="fa fa-link"></i>
              <a href="https://onelink.to/speetar.academia">رابط تحميل التطبيق</a>
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl, apiUrl, api } from "@/utils/api"; // Adjust the import path according to your project structure
import VideoClass from "./video.vue";
import ShareModal from "./share.vue";
import Swal from "sweetalert2";

import {
  showCart,
  addToCart,
  confirmPurchase,
  applyCoupon,
  removeCartItem,
  removeCoupon,
  generateCartInvoice,
} from "@/utils/cart";
export default {
  name: "CourseDetails",
  components: {
    VideoClass,
    ShareModal,
  },
  data() {
    return {
      token: localStorage.getItem("access_token"),
      baseUrl: baseUrl, // Adjust as per your .env configuration
      courseId: this.$route.query.id,
      defaultImage: "/assets/img/acad-icon.png",
      enrolledCourses: [], // Store enrolled courses here
      courseDetails: {
        course: {
          category: {},
          user: {},
          tele_group: "",
        }, // Initialize with an empty object
      },
      courseclass: 0,
      units: [], // To store units data
      selectedUnitIndex: 0, // Index of the selected unit
      loading: true, // Add loading state
    };
  },
  computed: {
    totalChapters() {
      return this.courseDetails.course.units.reduce((acc, unit) => {
        return acc + unit.chapters.length;
      }, 0);
      return 0;
    },
    totalClasses() {
      let total = 0;
      this.courseDetails.course.units.forEach((unit) => {
        unit.chapters.forEach((chapter) => {
          total += chapter.classes.length;
        });
      });
      return total;
    },
  },
  mounted() {
    this.fetchCourseDetails().then(() => {
      // Check for vc parameter in URL after course details are loaded
      const urlParams = new URLSearchParams(window.location.search);
      const videoId = urlParams.get('vc');
      if (videoId) {
        this.playVideoById(videoId);
      }
    });
    this.myCourses();
  },
  methods: {
    // New method to find and play video by ID
    async playVideoById(videoId) {
      // Find the video in the course structure
      for (const unit of this.units) {
        for (const chapter of unit.chapters) {
          const foundClass = chapter.classes.find(cls => cls.id == videoId);
          if (foundClass) {
            // Wait for the next tick to ensure the DOM is updated
            await this.$nextTick();
            this.playClass(foundClass);
            return true;
          }
        }
      }
      console.warn('Video with ID', videoId, 'not found');
      return false;
    },
    
    // Method to update URL with video ID
    updateUrlWithVideoId(videoId) {
      const url = new URL(window.location);
      url.searchParams.set('vc', videoId);
      window.history.pushState({}, '', url);
    },
    async toggleCheckB(item, type, parent = null) {
      const isChecked = !item.is_checked; // الحالة الجديدة

      // ✅ تحديث فوري في الواجهة قبل Swal و قبل الباك اند
      item.is_checked = isChecked;

      if (type === "Unit") {
        item.chapters.forEach((ch) => {
          ch.is_checked = isChecked;
          ch.classes.forEach((cl) => (cl.is_checked = isChecked));
        });
      }

      if (type === "course_chapter") {
        item.classes.forEach((cl) => (cl.is_checked = isChecked));
      }

      Swal.fire({
        title: isChecked ? "تأكيد التحديد" : "تأكيد إلغاء التحديد",
        text: "هل أنت متأكد من هذه العملية؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const endpoint = isChecked
              ? `${apiUrl}/course/progress/check`
              : `${apiUrl}/course/progress/uncheck`;

            await fetch(endpoint, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-country-code": "+218",
                Authorization: `Bearer ${this.token}`,
              },
              body: JSON.stringify({
                model_id: item.id,
                model_type: type,
              }),
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          // ❌ لو المستخدم لغى → رجّع الوضع القديم
          item.is_checked = !isChecked;

          if (type === "Unit") {
            item.chapters.forEach((ch) => {
              ch.is_checked = item.is_checked;
              ch.classes.forEach((cl) => (cl.is_checked = item.is_checked));
            });
          }

          if (type === "course_chapter") {
            item.classes.forEach((cl) => (cl.is_checked = item.is_checked));
          }
        }
      });
    },
    async toggleCheck(item, type, parent = null) {
      const isChecked = !item.is_checked; // الحالة الجديدة

      // ✅ تحديث فوري في الواجهة
      item.is_checked = isChecked;

      if (type === "Unit") {
        item.chapters.forEach((ch) => {
          ch.is_checked = isChecked;
          ch.classes.forEach((cl) => (cl.is_checked = isChecked));
        });
      }

      if (type === "course_chapter") {
        item.classes.forEach((cl) => (cl.is_checked = isChecked));
      }

      try {
        const endpoint = isChecked
          ? `${apiUrl}/course/progress/check`
          : `${apiUrl}/course/progress/uncheck`;

        await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify({
            model_id: item.id,
            model_type: type,
          }),
        });
      } catch (error) {
        console.error(error);
      }
    },

    async enrollFree(courseId) {
      Swal.fire({
        title: "تأكيد الإشتراك",
        text: "هل أنت متأكد من هذه العملية؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "نعم",
        cancelButtonText: "إلغاء",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const endpoint = `${apiUrl}/free/enroll`;

            const response = await fetch(endpoint, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-country-code": "+218",
                Authorization: `Bearer ${this.token}`,
              },
              body: JSON.stringify({
                course_id: courseId,
              }),
            });

            const data = await response.json();

            if (data.status === "success") {
              Swal.fire({
                icon: "success",
                title: "تم الإشتراك بنجاح",
                text: data.message || "لقد تم تسجيلك في الدورة",
                confirmButtonText: "موافق",
              }).then(() => {
                window.location.reload(); // إعادة تحميل الصفحة
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "خطأ",
                text: data.message || "حدث خطأ أثناء الإشتراك",
              });
            }
          } catch (error) {
            console.error(error);
            Swal.fire({
              icon: "error",
              title: "خطأ",
              text: "تعذر الاتصال بالخادم",
            });
          }
        }
      });
    },

    formattedDuration(durationInSeconds) {
      const totalSeconds = Number(durationInSeconds);

      if (isNaN(totalSeconds)) {
        return "Invalid duration";
      }

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      return `${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
    },
    calculateDiscountPercentage(price, discountPrice) {
      if (price > 0) {
        return Math.round(((price - discountPrice) / price) * 100);
      }
      return 0;
    },
    async fetchCourseDetails() {
      const data = {
        course_id: this.courseId,
        get_duration: 1, // Assuming you need to fetch duration as well
      };

      try {
        const response = await fetch(`${apiUrl}/desktop/course-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch course details");
        }

        const responseData = await response.json();
        this.courseDetails = responseData; // Store all course details
        //this.courseclass = responseData.course.courseclass.length; // Store all course details
        let shareModal = document.getElementById("share-content");

        shareModal.innerHTML = `
          <div style="text-align:right">
              تطبيق اكاديميا📚📱<br><br>
              ${responseData.course.title}<br><br>
              <a href="https://instructor.academia.ly/course/?id=${responseData.course.id}" target="_blank">https://instructor.academia.ly/course/?id=${responseData.course.id}</a><br><br>
              لتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام
          </div>
          <div id="copyButton" class="mt-3 btn-sm btn btn-success">نسخ للمشاركة <i class="fa fa-copy"></i></div>
      `;

        document
          .getElementById("copyButton")
          .addEventListener("click", async function () {
            // Define the text to be copied
            const textToCopy = `تطبيق اكاديميا📚📱\n\n${responseData.course.title}\n\nhttps://instructor.academia.ly/course/?id=${responseData.course.id}\n\nلتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام`;

            try {
              // Use the Clipboard API to copy the text
              await navigator.clipboard.writeText(textToCopy);
              // Optionally, show a confirmation message
              Swal.fire({
                icon: "success",
                title: "تمت المشاركة بنجاح",
                text: "",
                confirmButtonText: "حسناً",
              });
            } catch (err) {
              console.error("فشل النسخ:", err);
              alert("فشل في نسخ النص. يرجى المحاولة مرة أخرى.");
            }
          });
        let shareWebModal = document.getElementById("share-web-content");

        shareWebModal.innerHTML = `
                <div style="text-align:right">
                    تطبيق اكاديميا📚📱<br><br>
                    ${responseData.course.title}<br><br>
                    <a href="https://system.academia.education/course-details?id=${responseData.course.id}" target="_blank">https://system.academia.education/course-details?id=${responseData.course.id}</a><br><br>
                    لتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام
                </div>
                <div id="copyButtonWeb" class="mt-3 btn-sm btn btn-success">نسخ للمشاركة <i class="fa fa-copy"></i></div>
              `;

        document
          .getElementById("copyButtonWeb")
          .addEventListener("click", async function () {
            // Define the text to be copied
            const textToCopy = `تطبيق اكاديميا📚📱\n\n${responseData.course.title}\n\nhttps://system.academia.education/course-details?id=${responseData.course.id}\n\nلتواصل و الاستفسار يرجـى التواصل على 0913103064 تليغرام`;

            try {
              // Use the Clipboard API to copy the text
              await navigator.clipboard.writeText(textToCopy);
              // Optionally, show a confirmation message
              Swal.fire({
                icon: "success",
                title: "تمت المشاركة بنجاح",
                text: "",
                confirmButtonText: "حسناً",
              });
            } catch (err) {
              console.error("فشل النسخ:", err);
              alert("فشل في نسخ النص. يرجى المحاولة مرة أخرى.");
            }
          });
        if (responseData.course.units && responseData.course.units.length > 0) {
          this.units = responseData.course.units; // Store units data
          console.log(responseData.course.units);
        }
      } catch (error) {
        console.error("Error fetching course details:", error);
        // Handle error as per your application's requirements
      } finally {
        this.loading = false; // Set loading to false after fetching data
      }
    },
    isEnrolled(courseId) {
      return this.enrolledCourses.some((course) => course.id === courseId);
    },
    playClass(course_class) {
    // Update URL with the current video ID
    this.updateUrlWithVideoId(course_class.id);
    
      let isLive = course_class.is_live;
      let videoSection = document.getElementById("video-section");
      let videoLoader = document.getElementById("video-loader");
      videoSection.innerHTML = "";
      videoLoader.innerHTML =
        '<div class="video-loader text-success"> جاري التحميل  <div class="spinner-border text-success" role="status"><span class="sr-only"></span></div></div>';
      var myModal = new bootstrap.Modal(document.getElementById("video-modal"));
      myModal.show();
      const videoModal = document.getElementById("video-modal");
      videoModal.addEventListener("hidden.bs.modal", () => {
        videoSection.innerHTML = "";
      });
      document.getElementById("ClassId").value = course_class.id;
      this.$refs.vdRef.showClassNotes();
      if (isLive == false) {
        api(
          "/video-cipher-metadata",
          "POST",
          { url: course_class.vc, class_id: course_class.id },
          { Authorization: `Bearer ${this.token}` },
          false
        ).then(async (response) => {
          videoLoader.innerHTML = " ";
          let res = await response.json();

          const isChrome =
            /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

          if (isChrome) {
            const speedOptions = [1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0];
            videoSection.innerHTML += `
                <div style="text-align: right;direction: rtl;padding: 10px;background:#dddddd63;font-weight: 700;margin:15px 17px;border-radius:10px;line-height: 0px;">
                  <label style="font-weight:600" for="speedSelect">سرعة التشغيل:</label>
                  <select style="border-color: #00c544" id="speedSelect" onchange="changeSpeed()">
                    ${speedOptions
                      .map((speed) => `<option value="${speed}">${speed}x</option>`)
                      .join("")}
                  </select>
                </div>
              `;
          }
          videoSection.innerHTML += `
              <div class="card">
                <div class="card-body">
                  <h4 class="header-title mb-5">${course_class.title}</h4>
                  <div class="embed-responsive embed-responsive-21by9">
                    <iframe
                      id="vdoCipherPlayer"
                      src="https://player.vdocipher.com/v2/?otp=${res.otp}&playbackInfo=${res.playbackInfo}&primaryColor=00c544"
                      style="border:3px solid #00c544;max-width:100%;position:absolute;top:0;left:0;height:450px;width:100%;"
                      allow="encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <!--<div class="media mb-4 mt-4">
                    <img class="d-flex mr-3 rounded-circle avatar-sm" src="assets/img/instructor.png" alt="" height="50" width="50">
                    <div class="media-body">
                      <h5 class="font-size-14">${course_class.instructor}</h5>
                      ${course_class.details}
                    </div>
                  </div>-->
                </div>
              </div>
            `;
          if (isChrome) {
            window.changeSpeed = function () {
              const speedSelect = document.getElementById("speedSelect");
              const selectedSpeed = speedSelect.value;
              const playerIframe = document.getElementById("vdoCipherPlayer");
              const player = VdoPlayer.getInstance(playerIframe);
              if ("playbackRate" in player.video) {
                player.video.playbackRate = parseFloat(selectedSpeed);
              } else {
                console.error("Playback rate not supported by the player.");
              }
            };
          }
          const playerIframe = document.getElementById("vdoCipherPlayer");
          const player = VdoPlayer.getInstance(playerIframe);

          setInterval(() => {
            if (
              player &&
              player.video &&
              typeof player.video.currentTime !== "undefined"
            ) {
              document.getElementById("videoCurrentTime").value =
                player.video.currentTime;
            }
          }, 5000);
        });
      } else {
        videoLoader.innerHTML = "";

        const currentTime = new Date().getTime();
        const liveStartTime = new Date(course_class.live_starts_at).getTime();
        const liveEndTime = new Date(course_class.live_ends_at).getTime();

        let statusHTML = "";

        if (currentTime < liveStartTime) {
          // البث لم يبدأ بعد
          statusHTML = `<p class="text-success" style="#00bc2c !important"><i class="fa fa-clock"></i> سيبدأ البث في ${course_class.live_starts_at}</p>`;
          //statusHTML = `<button id="joinLiveBtn" class="btn btn-dark mt-3 btn-sm"><i class="fa fa-arrow-right"></i> انضم الآن</button>`;
        } else if (currentTime >= liveStartTime && currentTime <= liveEndTime) {
          // البث جاري الآن
          statusHTML = `<button id="joinLiveBtn" class="btn btn-dark mt-3 btn-sm"><i class="fa fa-arrow-right"></i> انضم الآن</button>`;
        } else {
          // البث انتهى
          statusHTML = `<p class="text-danger"><i class="fa fa-times-circle text-danger"></i> انتهى البث</p>`;
          //statusHTML = `<button id="joinLiveBtn" class="btn btn-dark mt-3 btn-sm"><i class="fa fa-arrow-right"></i> انضم الآن</button>`;
        }

        videoSection.innerHTML = `
        <div class="stream-box m-2 text-center">
          <h2><i class="fa fa-circle text-danger" aria-hidden="true"></i>

             ${course_class.title}
          </h2>
          <table class="stream-table">
            <tr>
              <th>بداية البث</th>
              <td>${course_class.live_starts_at}</td>
            </tr>
            <tr>
              <th>ينتهي البث</th>
              <td>${course_class.live_ends_at}</td>
            </tr>
          </table>
          <div class="m-3" style="font-weight:800;font-size:medium">
            ${statusHTML}
          </div>

        </div>
      `;
        // التأكد من أن الزر موجود ثم استدعاء `joinLiveStream` عند الضغط عليه
        const joinLiveBtn = document.getElementById("joinLiveBtn");
        if (joinLiveBtn) {
          joinLiveBtn.addEventListener("click", () => {
            const button = joinLiveBtn;
            const originalHTML = button.innerHTML; // حفظ النص الأصلي للزر
            button.innerHTML =
              '<span class="spinner-border spinner-border-sm"></span> جاري الانضمام...';
            button.disabled = true; // تعطيل الزر أثناء التحميل
            this.joinLiveStream(course_class); // استدعاء الفنكشن من `methods`
            setTimeout(() => {
              button.innerHTML = originalHTML; // إعادة النص الأصلي للزر
              button.disabled = false; // إعادة تفعيل الزر
            }, 3000);
          });
        }
      }
    },
    showPdf(course_class) {
      const pdfUrl = `${course_class.pdf}`;

      window.open(pdfUrl, "_blank"); // Opens the PDF in a new tab
    },
    showCart,
    addToCart,
    removeCartItem,
    setDefaultImage(event) {
      event.target.src = this.defaultImage;
    },
    async myCourses() {
      this.loadingCourses = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/desktop/my-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
            "x-country-code": "+218",
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.enrolledCourses = data.courses; // Store the enrolled courses
        } else if (response.status === 401 || response.status === 403) {
          //this.$router.push("/logout");
        } else {
          console.error("Failed to fetch student details");
        }
      } catch (error) {
        console.error("Error fetching student details:", error);
        //this.$router.push("/logout");
      } finally {
        this.loadingCourses = false; // Stop loading
      }
    },
    async joinLiveStream(course_class) {
      try {
        const response = await fetch(`${apiUrl}/livestream/token/` + course_class.id, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
        });

        let data = await response.json();

        if (data.token) {
          // تحويل المستخدم إلى رابط البث مع التوكن
          window.open(`https://live.academia.ly/?token=${data.token}`, "_blank");
        } else {
          alert("فشل في جلب التوكن، حاول مرة أخرى!");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
        alert("حدث خطأ أثناء الاتصال بالخادم!");
      }
    },
  },
};
</script>

<style scoped>
/* Add your scoped CSS here */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 24px;
  font-weight: bold;
}

/* إخفاء الشكل العادي */
.custom-checkbox {
  margin: 5px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #00c744;
  border-radius: 6px; /* يخليها ناعمة */
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease-in-out;
  margin-right: 8px;
  vertical-align: middle;
  background-color: #fff;
}

/* لما يتأشر */
.custom-checkbox:checked {
  background-color: #00c744;
  border-color: #00c744;
}

/* علامة الصح */
.custom-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #fff;
}

/* تأثير hover */
.custom-checkbox:hover {
  box-shadow: 0 0 5px rgba(0, 199, 68, 0.6);
}
</style>
